import { isEmpty } from 'lodash';

export function hasKeys(obj) {
    if (!isEmpty(obj)) {
        return true
    }
    else {
        return false
    }
}

export function isTeacherRole() {
    return [2, 3].includes(+localStorage.getItem('role_id'));
}
export function isAdminRole() {
    return localStorage.getItem('admin') == 'true' ? true : false;
}
export function truncateText(text, maxLength) {
    if (text.length <= maxLength) return text;
  
    let truncated = text.slice(0, maxLength);
  
    // Avoid cutting off in the middle of a word
    const lastSpace = truncated.lastIndexOf(' ');
    if (lastSpace > 0) {
      truncated = truncated.slice(0, lastSpace);
    }
  
    return truncated + '...';
  }